import styled, { css } from 'styled-components';

export const Heading1 = styled.h1`
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    font-size: 60px;
    line-height: 72px;
    letter-spacing: -0.5px;
    font-weight: 400;
    color: ${({ theme }) => theme.bento.colors.text.main};
    margin: 0;
`;

export const Heading2 = styled.h2`
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    font-size: 48px;
    line-height: 56px;
    letter-spacing: 0;
    font-weight: 400;
    color: ${({ theme }) => theme.bento.colors.text.main};
    margin: 0;
`;

export const Heading3 = styled.h3`
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0;
    font-weight: 600;
    color: ${({ theme }) => theme.bento.colors.text.main};
    margin: 0;
`;

export const Heading4 = styled.h4`
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.25px;
    font-weight: 600;
    color: ${({ theme }) => theme.bento.colors.text.main};
    margin: 0;
`;

export const Title = styled.h5`
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    color: ${({ theme }) => theme.bento.colors.text.main};
    margin: 0;
`;

export const Subtitle = styled.h6`
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.25px;
    font-weight: 600;
    color: ${({ theme }) => theme.bento.colors.text.main};
    margin: 0;
`;

export const Body1 = styled.p`
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    font-weight: 500;
    color: ${({ theme }) => theme.bento.colors.text.main};
    margin: 0;
`;

export const Body1Alt = styled(Body1)`
    font-weight: 700;
`;

export const Body2 = styled.p`
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    font-weight: 500;
    color: ${({ theme }) => theme.bento.colors.text.main};
    margin: 0;
`;

export const Body2Alt = styled(Body2)`
    font-weight: 700;
`;

export const linkStyles = css`
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    color: ${({ theme }) => theme.bento.colors.primary.main};
    text-decoration: none;
    cursor: pointer;
    &:hover {
        color: ${({ theme }) => theme.bento.colors.primary.strong};
    }
`;

export const Link = styled.a`
    ${linkStyles}
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    font-weight: 500;
`;

export const Caption = styled.p`
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.5px;
    font-weight: 600;
    color: ${({ theme }) => theme.bento.colors.text.main};
    margin: 0;
`;

export const Overline = styled.p`
    font-family: ${({ theme }) => theme.bento.font.primary.family};
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.5px;
    font-weight: 700;
    color: ${({ theme }) => theme.bento.colors.text.main};
    text-transform: uppercase;
    margin: 0;
`;
